"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.borders = void 0;
Object.defineProperty(exports, "radius", {
  enumerable: true,
  get: function get() {
    return _borderTokens.radius;
  }
});
Object.defineProperty(exports, "width", {
  enumerable: true,
  get: function get() {
    return _borderTokens.width;
  }
});
var _borderTokens = require("./border-tokens");
var borders = exports.borders = {
  radius: _borderTokens.radius,
  width: _borderTokens.width
};
var _default = exports["default"] = borders;